import { format } from "date-fns";
import { Container, Grid, Stack, Text } from "basis";
import { formatAmount } from "library/moneyUtils";

function BpayDetails({
  biller,
  referenceNumber,
  amount,
  paymentDate,
  receiptNumber,
}) {
  return (
    <Container hasBorder padding="4">
      <Stack gap="6">
        <Stack gap="4">
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
            <Grid.Item colSpan="all" colSpan-sm="0-2">
              <Text color="grey.t75">Biller name</Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="3-7">
              <Text>
                <strong>{biller.name}</strong>
              </Text>
            </Grid.Item>
          </Grid>
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
            <Grid.Item colSpan="all" colSpan-sm="0-2">
              <Text color="grey.t75">Biller code</Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="3-7">
              <Text>
                <strong>{biller.code}</strong>
              </Text>
            </Grid.Item>
          </Grid>
          {referenceNumber && (
            <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
              <Grid.Item colSpan="all" colSpan-sm="0-2">
                <Text color="grey.t75">Reference number</Text>
              </Grid.Item>
              <Grid.Item colSpan="all" colSpan-sm="3-7">
                <Text>
                  <strong>{referenceNumber}</strong>
                </Text>
              </Grid.Item>
            </Grid>
          )}
          {amount && (
            <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
              <Grid.Item colSpan="all" colSpan-sm="0-2">
                <Text color="grey.t75">Amount</Text>
              </Grid.Item>
              <Grid.Item colSpan="all" colSpan-sm="3-7">
                <Text>
                  <strong>{formatAmount(amount, { withCents: true })}</strong>
                </Text>
              </Grid.Item>
            </Grid>
          )}
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
            <Grid.Item colSpan="all" colSpan-sm="0-2">
              <Text color="grey.t75">Payment date</Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="3-7">
              <Text>
                <strong>{format(paymentDate, "dd MMMM yyyy")}</strong>
              </Text>
            </Grid.Item>
          </Grid>
          {receiptNumber && (
            <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="1">
              <Grid.Item colSpan="all" colSpan-sm="0-2">
                <Text color="grey.t75">Receipt number</Text>
              </Grid.Item>
              <Grid.Item colSpan="all" colSpan-sm="3-7">
                <Text>
                  <strong>{receiptNumber}</strong>
                </Text>
              </Grid.Item>
            </Grid>
          )}
        </Stack>
      </Stack>
    </Container>
  );
}

export { BpayDetails };
